import React, { PureComponent, useState, useMemo, useEffect, useCallback } from 'react';
import { ReactTinyLink } from 'react-tiny-link';
import handleViewport from 'react-in-viewport';
import schemify from 'url-schemify';
import urlParse from 'url-parse';

import { unshortenUrl } from 'api/global-api';
import { fetchMessage } from 'api/messages-api';

import config from '../config'
import { corsFree, buildAppUrl } from 'utils/url';
import { escapeRegExp } from 'utils/helpers';

import MessagePreview from 'components/MessagePreview';

import IconClose from 'icons/icon-close';

const errors = [];

const NiftyResourcePreview = ({ pathname }) => {
    const [resource, setResource] = useState(null);

    const type = useMemo(() => {
        if (pathname.indexOf('/discussion/message/') > -1) {
            return 'message';
        }

        return null
    }, [pathname]);

    const resourceId = useMemo(() => {
        if (type === 'message') {
            return pathname.split('/discussion/message/')[1];
        }

        return null;
    }, [type, pathname]);

    const fetchResource = useCallback(async () => {
        if (!type || !resourceId) {
            return;
        }

        try {
            if (type === 'message') {
                const message = await fetchMessage(resourceId);

                setResource(message);
            }

        } catch (e) {}

    }, [type, resourceId]);


    useEffect(() => {
        fetchResource();
    }, [fetchResource]);

    if (!type || !resource) {
        return null;
    }

    if (type === 'message') {
        return (
            <div className="nifty-resource-preview">
                <MessagePreview controlsDisabled={true} {...resource} />
            </div>
        )
    }

    return null;
}

class UrlPreview extends PureComponent {
    state = {
        hasError: false,
        isNiftyResource: false,
        loading: true
    }

    handleError = e => {
        this.setState({
            hasError: true
        });
    }

    handleLoad = () => {
        this.setState({
            loading: false
        });
    }

    get niftyShortenedToken() {
        const appUrl = buildAppUrl('/l/').replace('https://', '');

        return this.props.url && this.props.url.match(new RegExp(escapeRegExp(appUrl) + '(.+)'))?.[1];
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        });
    }

    componentDidMount() {
        if (this.niftyShortenedToken) {
            this.setState({
                isNiftyResource: true
            });

            unshortenUrl(this.niftyShortenedToken, url => {
                const urlProps = urlParse(url);

                if (urlProps?.pathname) {
                    this.setState({
                        niftyResourcePathname: urlProps.pathname
                    });
                } else {
                    this.setState({
                        isNiftyResource: false
                    });
                }
            }, () => {
                this.setState({
                    hasError: true
                });
            });
        }
    }

    render() {
        if (!config.ENABLE_URL_PREVIEWS || !this.props.url || this.state.hasError) {
            return null;
        }

        return (
            <div className={'url-preview' + (this.state.isNiftyResource ? ' url-preview-nifty-resource' : ' url-preview-generic') + (this.state.loading ? ' loading' : '')}>
                {
                    this.props.isSelf ? (
                        <button className="btn preview-remove" onClick={this.props.onUrlPreviewRemove}>
                            <IconClose />
                        </button>
                    ) : null
                }

                {
                    this.state.isNiftyResource ? (
                        <NiftyResourcePreview pathname={this.state.niftyResourcePathname} />
                    ) : this.props.inViewport ? (
                        <div className="url-preview-generic">
                            <ReactTinyLink
                                url={schemify(this.props.url)}
                                width={'367px'}
                                maxLine={1}
                                cardSize="large"
                                target="_blank"
                                proxyUrl={corsFree('')}
                                onError={this.handleError}
                                onSuccess={this.handleLoad}
                            />
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export default handleViewport(UrlPreview)
